import { Button } from "@unizpay/ui";
import { ArrowRight, Code2, LayoutDashboard, Link2 } from "lucide-react";
import { useMode } from "../../../lib/mode";
import type { Profile } from "../../../lib/types";
import { StepCard } from "../StepChrome";

export function DoneView({ profile, finish }: { profile: Profile; finish: (to: string) => void }) {
  const { testMode } = useMode();
  const next = [
    {
      to: "/dashboard",
      icon: LayoutDashboard,
      title: "Go to the dashboard",
      text: "See payments and volume.",
    },
    {
      to: "/payments",
      icon: Link2,
      title: "Create a payment link",
      text: "A link you share; your customer pays on checkout.",
    },
    {
      to: "/developers/api-keys",
      icon: Code2,
      title: "Get an API key",
      text: "Create payments from your server.",
    },
  ];
  return (
    <StepCard
      title={`${profile.name} is ready`}
      description={
        testMode
          ? "You can try everything in test mode first, without real funds."
          : "Try it with a small real payment first: a $1 payment costs a few cents of network fees."
      }
      footer={
        <Button onClick={() => finish("/dashboard")}>
          Go to dashboard <ArrowRight aria-hidden="true" />
        </Button>
      }
    >
      <ul className="divide-y divide-line rounded-lg border border-line bg-surface">
        {next.map((n) => (
          <li key={n.to}>
            <button
              type="button"
              onClick={() => finish(n.to)}
              className="flex w-full items-center gap-3 px-4 py-3 text-left hover:bg-subtle"
            >
              <span className="flex size-8 shrink-0 items-center justify-center rounded-md bg-accent/10 text-accent">
                <n.icon aria-hidden="true" className="size-4" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-medium">{n.title}</span>
                <span className="block text-xs text-fg-muted">{n.text}</span>
              </span>
              <ArrowRight aria-hidden="true" className="size-4 text-fg-subtle" />
            </button>
          </li>
        ))}
      </ul>
    </StepCard>
  );
}
